var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ContentBaseComponent } from '../../../../component/base/contentbase.component';
import { KtsConstructionTypeService, ConstructionTypeTemplate } from './construction-type.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../../../action/au.action';
import { MessageService } from '../../../../service/message.service';
import { PageService } from '../../../../models/page.service';
import { ValidationService } from '../../../../service/validation.service';
var KtsConstructionTypeComponent = /** @class */ (function (_super) {
    __extends(KtsConstructionTypeComponent, _super);
    function KtsConstructionTypeComponent(router, route, logger, action, message, page, service, validService) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.validService = validService;
        _this.item = new ConstructionTypeTemplate();
        _this.type = [];
        _this.readonly = false;
        return _this;
    }
    KtsConstructionTypeComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.getType();
        this.setCompRec();
    };
    KtsConstructionTypeComponent.prototype.setUnsubscribe = function () {
        this.changeSubscription.unsubscribe();
    };
    KtsConstructionTypeComponent.prototype.onSubscribe = function (data) {
        this.setCompRec();
    };
    KtsConstructionTypeComponent.prototype.getType = function () {
        var _this = this;
        this.service.getType('CONSTRUCTION_TYPE').subscribe(function (rec) { return _this.type = rec; });
    };
    KtsConstructionTypeComponent.prototype.onEventSubscribe = function (e) {
        if (e === 'languageChange') {
            this.getType();
        }
    };
    KtsConstructionTypeComponent.prototype.onEvent = function (e1, e2, rec) {
    };
    KtsConstructionTypeComponent.prototype.onChange = function (e) {
        this.item[e.key] = e.val;
        this.setCompRec();
    };
    KtsConstructionTypeComponent.prototype.setCompRec = function () {
        if (this.item.construction_type === 'general') {
            delete this.item['construction_classification_id'];
            delete this.item['construction_middle_classification_id'];
        }
        this.action.setCompRec(this.componentName, this.item);
    };
    KtsConstructionTypeComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-construction-type',
                    template: "<form id=\"{{ componentName }}\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <column [key]=\"'form'\" [col]=\"{\n        key: 'construction_type',\n        label: (msg | async)['au.COMPONENT.KtsConstructionTypeComponent.label.construction_type'],\n        controlType: 'radio',\n        required: true,\n        readonly: (mode !== 'entry'),\n        params: {options: type}\n      }\" [val]=\"item\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event)\"></column>\n    </div>\n  </div>\n  <ng-template [ngIf]=\"item.construction_type === 'expand'\">\n    <div class=\"row -mt-1\">\n      <div class=\"col-sm-12\">\n        <column [key]=\"'form'\" [col]=\"{\n          label: (msg | async)['au.COMPONENT.KtsConstructionTypeComponent.label.construction_class'],\n          controlType: 'constructionClassification',\n          required: true,\n          readonly: (mode === 'confirm'),\n          params: {\n            classification: {\n              key: 'construction_classification_id'\n            },\n            middleClassification: {\n              key: 'construction_middle_classification_id'\n            }\n          }\n        }\" [val]=\"item\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event)\"></column>\n      </div>\n    </div>\n  </ng-template>  \n</form>\n"
                }] }
    ];
    /** @nocollapse */
    KtsConstructionTypeComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: KtsConstructionTypeService },
        { type: ValidationService }
    ]; };
    return KtsConstructionTypeComponent;
}(ContentBaseComponent));
export { KtsConstructionTypeComponent };
//# sourceMappingURL=construction-type.component.js.map